import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import MicrosoftCallback from 'views/pages/authentication/auth-forms/MicrosoftCallback';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const Emailforgotpassword = Loadable(lazy(() => import('views/pages/authentication/forgotPassword/EmailForgotPassword')));
const RememberPassword = Loadable(lazy(() => import('views/pages/authentication/forgotPassword/ForgotPassword')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/login',
            element: <AuthLogin3 />
        },
        {
            path: '/',
            element: <AuthLogin3 />
        },
        {
            path: '/recuperar-senha',
            element: <Emailforgotpassword />
        },
        {
            path: '/redefinir-senha',
            element: <RememberPassword />
        },
        {
            path: '/microsoft/callback',
            element: <MicrosoftCallback />
        }
    ]
};

export default AuthenticationRoutes;
